import React, { useEffect, useState } from "react";
import { createTheme, ThemeProvider, styled } from "@mui/material/styles";
import {
  Box,
  FormControl,
  InputLabel,
  makeStyles,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import rtlPlugin from "stylis-plugin-rtl";
import { prefixer } from "stylis";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import { useSelector } from "react-redux";
const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
});

// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

export default function DropdownCmp({
  options,
  label = "نامشخص",
  value,
  name,
  id,
  onChange,
  error,
  onBlur,
  onSelect,
  onClick,
  isVehicle,
  marginRight,
  paddingRight,
  textAlign,
  disable,
}: {
  options: any;
  label: string;
  value?: any;
  name: any;
  id: any;
  onChange: any;
  error?: any;
  onBlur?: any;
  onSelect?: any;
  onClick?: any;
  isVehicle?: boolean;
  marginRight?: any;
  paddingRight?: any;
  textAlign?: any;
  disable?: boolean;
}) {
  const [values, setValues] = React.useState(value);
  const jsonFile = useSelector((state: any) => state.style);
  const css = `
.Mui-selected{
    background: ${jsonFile?.mainColor} !important;
},

`;

  return (
    <CacheProvider value={cacheRtl}>
      <style>{css}</style>
      <ThemeProvider theme={theme}>
        <div dir="rtl">
          <FormControl
            fullWidth
            sx={{
              "& .MuiMenu-list": {
                backgroundColor: "#1B3045",
              },
            }}
          >
            <InputLabel
              htmlFor="outlined-age-simple"
              color={jsonFile?.muiColor}
              style={{ top: "-2.5px" }}
              sx={{
                "&.MuiInputLabel-shrink": {
                  // color: jsonFile?.mainColor,
                  fontSize: "12px",
                  fontWeight: "bold",
                },
              }}
            >
              {label}
            </InputLabel>
            <Select
              disabled={disable}
              onClick={onClick}
              onBlur={onBlur}
              error={error}
              value={value}
              color={jsonFile?.muiColor}
              onSelect={onSelect}
              onChange={onChange}
              input={<OutlinedInput name={name} id={name} label={label} />}
              style={{
                paddingTop: "6px",
                width: "100%",
                boxShadow:
                  "0 0px 1px 0 rgba(0, 0, 0, 0), 0 1px 1px 0 rgba(0, 0, 0, 0.2)",
                borderRadius: "3px",
                paddingRight: paddingRight ? paddingRight : "",
                textAlign: textAlign ? textAlign : "",
              }}
              MenuProps={{
                MenuListProps: {
                  sx: {
                    display: "flex",
                    flexDirection: "column",
                    marginRight: "-10px",
                  },
                },
                PaperProps: {
                  sx: {
                    backgroundColor: "#1B3045",
                    border: "2px solid #1B3045",
                    "& .MuiMenu-list": {
                      backgroundColor: "#1B3045",
                      paddingRight: " 2vh !important",
                      paddingLeft: " 2vh !important",
                    },
                    "&.MuiPopover-paper": {
                      backgroundColor: "#1B3045",
                      borderRadius: "5px !important",
                      maxHeight: "400px",
                      border: "2px solid #1B3045",
                    },
                  },
                },
              }}
            >
              {options != null &&
                options.length > 0 &&
                options.map((item: any, index: any) => (
                  <MenuItem
                    style={{
                      fontSize: "2px !important",
                      height: "45px",
                      borderBottom:
                        index === options.length - 1
                          ? "none"
                          : "1px solid rgba(255, 255, 255, 0.25)",
                      backgroundColor: "#1B3045",
                      color: "#fff",
                    }}
                    key={item.id}
                    value={
                      name == "vehicleType"
                        ? item.enumData
                        : name != "installmentCount"
                        ? item.id
                        : item.title
                    }
                  >
                    <p
                      className={`${
                        label == "*تعداد اقساط" ? "marginRight-14 " : " "
                      }`}
                      style={
                        marginRight
                          ? {
                              position: "relative",
                              // top: "50%",
                              transform: "translateY(39%)",
                              marginRight: marginRight,
                              textAlign: "center",
                              fontSize: "1rem",
                              // marginTop: "8px",
                            }
                          : {
                              position: "relative",
                              // top: "50%",
                              transform: "translateY(39%)",
                              fontSize: "1rem",
                              // marginTop: "8px",
                            }
                      }
                    >
                      {item.title}
                    </p>
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </div>
      </ThemeProvider>
    </CacheProvider>
  );
}
